import React from 'react';
import Slider from "react-slick";
import { useState, useEffect, useRef  } from "react";

function Team(){
    const settings = {
        dots: false,
        arrows:false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
           
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                autoplay: true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                autoplay: true,
              }
            }
          ]
      };
      const settings2 = {
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide:true,
        focusOnSelect:true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,

              }
            }
          ]
      };
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);
    useEffect(() => {
      setNav1(sliderRef1);
      setNav2(sliderRef2);
    }, []);
    return <>

<Slider className='our-team' asNavFor={nav2} ref={slider => (sliderRef1 = slider)} {...settings}>
        <div>
        <div className='OurTeamContent'>
            <div className='LeftWrap'>
                <img src={require('../../images/t1.webp')} alt=''/>
            </div>
            <div className='RightContent'>
                <img className='Img' src={require('../../images/rightteam.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Name'><span>Name:</span> Developer</p>
                    <p><span>Alter:</span> Alter</p>
                    <p><span>Funktion:</span> Funktion</p>
                    <p><span>Infos:</span> Infos Infos Infos</p>
                </div>
            </div>
        </div>
        </div>

        <div>
        <div className='OurTeamContent'>
            <div className='LeftWrap'>
                <img src={require('../../images/c1.webp')} alt=''/>
            </div>
            <div className='RightContent'>
                <img className='Img' src={require('../../images/rightteam.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Name'><span>Name:</span> Developer</p>
                    <p><span>Alter:</span> Alter</p>
                    <p><span>Funktion:</span> Funktion</p>
                    <p><span>Infos:</span> Infos Infos Infos</p>
                </div>
            </div>
        </div>
        </div>

        <div>
        <div className='OurTeamContent'>
            <div className='LeftWrap'>
                <img src={require('../../images/t1.webp')} alt=''/>
            </div>
            <div className='RightContent'>
                <img className='Img' src={require('../../images/rightteam.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Name'><span>Name:</span> Developer</p>
                    <p><span>Alter:</span> Alter</p>
                    <p><span>Funktion:</span> Funktion</p>
                    <p><span>Infos:</span> Infos Infos Infos</p>
                </div>
            </div>
        </div>
        </div>

        <div>
        <div className='OurTeamContent'>
            <div className='LeftWrap'>
                <img src={require('../../images/c2.webp')} alt=''/>
            </div>
            <div className='RightContent'>
                <img className='Img' src={require('../../images/rightteam.webp')} alt=''/>
                <div className='TextBox'>
                    <p className='Name'><span>Name:</span> Developer</p>
                    <p><span>Alter:</span> Alter</p>
                    <p><span>Funktion:</span> Funktion</p>
                    <p><span>Infos:</span> Infos Infos Infos</p>
                </div>
            </div>
        </div>
        </div>
      </Slider>
      <Slider className="thumb-wrapper teams-thumb" asNavFor={nav1} ref={slider => (sliderRef2 = slider)} {...settings2}>
                
                <div className='ThumbImg'>
                    <img src={require('../../images/t1.webp')} alt=''/>
                </div>

                <div className='ThumbImg'>
                    <img src={require('../../images/c1.webp')} alt=''/>
                </div>

                <div className='ThumbImg'>
                    <img src={require('../../images/t1.webp')} alt=''/>
                </div>

                <div className='ThumbImg'>
                    <img src={require('../../images/c2.webp')} alt=''/>
                </div>
    </Slider>
    </>
}
export default Team;